import { render, staticRenderFns } from "./cart-items.vue?vue&type=template&id=3df0d863&"
import script from "./cart-items.vue?vue&type=script&lang=js&"
export * from "./cart-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports